/* You Fly LA - Luxury Cirrus "Bring A Passenger" switch (v40, 2026-09-24).
   The Cirrus discovery flight is priced for one flyer ($499 / $649 / $799 for 60 / 90 / 120 min).
   A passenger adds $100 / $200 / $250 ($599 / $849 / $1,049) - the "Bring A Passenger" variant of the
   same product, booked through the same Cowlendar service (window.YFLA_COW_PAX in snippets/yfla-cow).
   Enhances, without editing their files: the flight cards ([data-dfc], flight-cards snippet and the
   discovery page) and the discovery booking board (.dfp-row with .dfb-opt links).
   Round 4 (2026-09-25, v41): the theme's static Cirrus text is now one-flyer ("one flyer", "Book Now"),
   so the two For-Two rewrites below are no-ops kept for safety; the passenger-on button reads
   "Book With A Passenger"; and a product page opened on the passenger variant (?variant=ID, e.g. from
   the gift page) no longer adds the surcharge twice to the phone bar.
   Round 11 (2026-09-26, v42): new Cirrus prices (owner decision 10) - the passenger add-ons below are now
   +$100 / +$200 / +$250; the one-flyer prices are read from the page, so they need no change here. */
(function () {
  'use strict';
  var PAX = window.YFLA_COW_PAX || {};
  var CAL = 'https://app.cowlendar.com/cal/';
  var ADD = {
    'luxury-cirrus-discovery-flight-for-two': 100,
    'luxury-cirrus-discovery-flight-for-two-90-minutes': 200,
    'luxury-cirrus-discovery-flight-for-two-120-minutes': 250
  };
  var NAME = 'Luxury Cirrus SR22 Discovery Flight';
  function num(s) { var m = String(s || '').replace(/,/g, '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
  function money(n) { return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function isLux(h) { return Object.prototype.hasOwnProperty.call(ADD, h); }
  function handleOf(a) {
    var h = a.getAttribute('data-yfla-handle');
    if (h) return h;
    var m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1] : '';
  }
  function css() {
    if (document.getElementById('ypx-css')) return;
    var s = document.createElement('style'); s.id = 'ypx-css';
    s.textContent =
      '.ypx{display:flex;align-items:center;gap:12px;margin:12px 0 4px;padding:10px 12px;border:1px solid color-mix(in srgb,currentColor 18%,transparent);border-radius:14px;background:color-mix(in srgb,currentColor 4%,transparent);min-height:56px}' +
      '.ypx-l{display:flex;flex-direction:column;gap:2px;flex:1;min-width:0;font:500 14px/1.3 Inter,system-ui,sans-serif;color:inherit;text-align:left}' +
      '.ypx-l b{font-weight:600;font-size:15px}.ypx-l span{font-size:12.5px;opacity:.72}' +
      '.ypx-sur{font:600 14px/1 "JetBrains Mono",ui-monospace,monospace;white-space:nowrap}' +
      '.ypx-sw{position:relative;flex:none;width:52px;height:32px;border-radius:999px;border:0;padding:0;background:#C7C7CF;cursor:pointer;transition:background .18s}' +
      '.ypx-sw::after{content:"";position:absolute;top:3px;left:3px;width:26px;height:26px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.3);transition:transform .18s}' +
      '.ypx-sw[aria-checked="true"]{background:#0066CC}.ypx-sw[aria-checked="true"]::after{transform:translateX(20px)}' +
      '.ypx-sw:focus-visible{outline:3px solid #0066CC;outline-offset:3px}' +
      '.ypx-hit{position:relative}.ypx-hit::before{content:"";position:absolute;inset:-6px -4px}' +
      '@media (prefers-reduced-motion:reduce){.ypx-sw,.ypx-sw::after{transition:none}}';
    document.head.appendChild(s);
  }
  function makeSwitch(sur) {
    var row = document.createElement('div'); row.className = 'ypx';
    row.innerHTML = '<span class="ypx-l"><b>Bring A Passenger</b><span>Instructor + 2 is our maximum</span></span>' +
      '<span class="ypx-sur" data-ypx-sur>' + sur + '</span>' +
      '<button type="button" class="ypx-sw ypx-hit" role="switch" aria-checked="false" aria-label="Bring a passenger"></button>';
    return row;
  }
  function point(a, h, on) {
    var p = PAX[h];
    a.removeAttribute('data-yfla-cal'); a.removeAttribute('data-cowlendar-btn'); a.removeAttribute('data-yfla-handle');
    if (on && p) {
      a.setAttribute('href', CAL + p[0] + '/' + p[1]);
      a.setAttribute('data-yfla-cal', '1');
      a.setAttribute('data-cowlendar-btn', p[0] + '-' + p[1]);
      a.setAttribute('data-yfla-handle', h);
    } else {
      a.setAttribute('href', '/products/' + h);
    }
  }
  function sweep() { if (window.YFLA_bookSweep) window.YFLA_bookSweep(); }

  /* Flight cards */
  function initCard(card) {
    if (card.getAttribute('data-ypx')) return;
    var opts = [].slice.call(card.querySelectorAll('[data-dfc-opt]'));
    if (!opts.length || !isLux(opts[0].getAttribute('data-handle'))) return;
    card.setAttribute('data-ypx', '1');
    opts.forEach(function (o) {
      o.setAttribute('data-sub', (o.getAttribute('data-sub') || '').replace(/two seats/i, 'one flyer'));
      o.setAttribute('data-cta', 'Book Now');
    });
    var line = card.querySelector('.dfc-priceline') || card.querySelector('[data-dfc-price]');
    var row = makeSwitch('+$100');
    if (line && line.parentNode) line.parentNode.insertBefore(row, line);
    var sw = row.querySelector('.ypx-sw');
    var on = false;
    function apply() {
      var o = card.querySelector('[data-dfc-opt].on') || opts[0];
      var h = o.getAttribute('data-handle'), base = num(o.getAttribute('data-price')), add = ADD[h] || 0;
      row.querySelector('[data-ypx-sur]').textContent = '+' + money(add);
      var price = card.querySelector('[data-dfc-price]');
      if (price) price.textContent = money(on ? base + add : base);
      var sub = card.querySelector('[data-dfc-sub]');
      if (sub) sub.innerHTML = on ? o.getAttribute('data-sub').replace(/one flyer/i, 'you + a passenger') : o.getAttribute('data-sub');
      var book = card.querySelector('[data-dfc-book]');
      if (book) {
        var lbl = book.querySelector('[data-dfc-cta]');
        if (lbl) lbl.textContent = on ? 'Book With A Passenger' : 'Book Now';
        point(book, h, on);
        if (!on) sweep();
      }
    }
    sw.addEventListener('click', function () { on = !on; sw.setAttribute('aria-checked', on ? 'true' : 'false'); apply(); });
    opts.forEach(function (o) { o.addEventListener('click', function () { setTimeout(apply, 0); }); });
    var t = card.querySelector('h3, h2, [data-dfc-title]');
    if (t && /for two/i.test(t.textContent)) t.textContent = t.textContent.replace(/\s*For Two/i, '');
    apply();
  }

  /* Discovery booking board */
  function initBoard(row) {
    if (row.getAttribute('data-ypx')) return;
    var links = [].slice.call(row.querySelectorAll('a.dfb-opt')).filter(function (a) { return isLux(handleOf(a)); });
    if (!links.length) return;
    row.setAttribute('data-ypx', '1');
    var base = links.map(function (a) { var b = a.querySelector('b'); return num(b ? b.textContent : ''); });
    var hs = links.map(handleOf);
    var title = row.querySelector('.dfb-main > b');
    if (title) title.textContent = NAME;
    var opts = row.querySelector('.dfb-opts');
    var sw_row = makeSwitch('+$100 · +$200 · +$250');
    if (opts && opts.parentNode) opts.parentNode.insertBefore(sw_row, opts.nextSibling);
    var sw = sw_row.querySelector('.ypx-sw');
    var on = false;
    function apply() {
      links.forEach(function (a, i) {
        var h = hs[i], add = ADD[h] || 0, p = on ? base[i] + add : base[i];
        var b = a.querySelector('b'); if (b) b.textContent = money(p);
        var len = (a.querySelector('i') || {}).textContent || '';
        a.setAttribute('aria-label', 'Book the ' + len.replace(/\s*Min/i, '-minute') + ' ' + NAME + (on ? ' with a passenger, ' : ' for one flyer, ') + money(p));
        point(a, h, on);
      });
      if (!on) sweep();
    }
    sw.addEventListener('click', function () { on = !on; sw.setAttribute('aria-checked', on ? 'true' : 'false'); apply(); });
    apply();
  }

  /* Product pages: keep the phone bottom bar in step with the Passengers option */
  function initProduct() {
    var m = location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    if (!m || !isLux(m[1])) return;
    var h = m[1], bar = document.querySelector('.yfla-mcta .m-book');
    if (!bar || bar.getAttribute('data-ypx')) return;
    bar.setAttribute('data-ypx', '1');
    var base = num(bar.textContent), p = PAX[h], b = (window.YFLA_COW || {})[h];
    /* the bar is rendered with the selected variant's price: if the page opened on the
       passenger variant, take the surcharge off to get the one-flyer base */
    var chk0 = document.querySelector('variant-picker input:checked, .variant-picker input:checked');
    var v0 = new URLSearchParams(location.search).get('variant') || '';
    if (p && base && (chk0 ? /passenger/i.test(chk0.value) : String(v0) === p[1])) base -= ADD[h];
    function sync() {
      var chk = document.querySelector('variant-picker input:checked, .variant-picker input:checked');
      var v = new URLSearchParams(location.search).get('variant') || '';
      var on = !!p && (chk ? /passenger/i.test(chk.value) : String(v) === p[1]);
      var c = on ? p : b;
      if (!c || !base) return;
      bar.setAttribute('href', CAL + c[0] + '/' + c[1]);
      bar.setAttribute('data-cowlendar-btn', c[0] + '-' + c[1]);
      bar.textContent = 'Book — ' + money(on ? base + ADD[h] : base);
    }
    document.addEventListener('change', function () { setTimeout(sync, 80); }, true);
    sync();
  }

  function run(root) {
    root = root || document;
    var any = false;
    [].slice.call(root.querySelectorAll('[data-dfc]')).forEach(function (c) { if (!c.getAttribute('data-ypx')) { any = true; initCard(c); } });
    [].slice.call(root.querySelectorAll('.dfp-row')).forEach(function (r) { if (!r.getAttribute('data-ypx')) { any = true; initBoard(r); } });
    if (any) css();
    initProduct();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  window.YFLA_paxRun = run;
})();